const MagistratMesureMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexWrap: "wrap",
  mt: "6",
  overFlow: "hidden",
  p: "3",
  position: "relative",
  width: "100%",
};

const MagistratMesureMainMandataireStyle = {
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  pt: 5,
  px: 4,
};

const MagistratMesureSideMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexBasis: 380,
  flexGrow: 1,
  minHeight: "320px",
};

const MagistratMesureTitleMandataireStyle = {
  color: "textSecondary",
  fontFamily: "heading",
  fontSize: 0,
  mb: "4px",
};

const MagistratMesureContentMandataireStyle = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: 4,
};

const MagistratTribunal = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: "5px",
};

const boxStyle = {
  flexGrow: 1,
};

const topTextStyle = {
  color: "black",
  fontWeight: "600",
  mb: "5px",
};

const MagistratMesureAntennesStyle = {
  bg: "white",
  borderRadius: "6px",
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  mt: "6",
  pt: 5,
  px: 4,
};

export {
  MagistratMesureMandataireStyle,
  MagistratMesureMainMandataireStyle,
  MagistratMesureSideMandataireStyle,
  MagistratMesureTitleMandataireStyle,
  MagistratMesureContentMandataireStyle,
  topTextStyle,
  boxStyle,
  MagistratMesureAntennesStyle,
  MagistratTribunal,
};
